import React, {
  useState,
  useEffect,
  useMemo,
  Fragment,
  useCallback,
} from "react";
import { NavLink } from "react-router-dom";
import {
  Autocomplete,
  Grid,
  TextField,
  CircularProgress,
  LinearProgress,
  Button,
} from "@mui/material";
import ReactPaginate from "react-paginate";
import Table from "../../Components/Common/Table/Table";
import {
  getInfoMessageNoResultsSearch,
  CommonSubHeader,
} from "../../Components/helpers/Helpers";
import Swal from "sweetalert2";
import TableActions from "../../Components/Common/Table/TableActions";
import { CleaningServices, PersonAdd, Search } from "@mui/icons-material";
import api from "../../api/axios";
import { CustomButtonPlusIcon } from "../../Components/Common/Design/CustomButtonPlusIcon";

function Usuarios({
  flagToShow = true,
  setCompanyFromUser = 0,
  setUsersControlNumber,
}) {
  const [user, setUser] = useState([]);
  const [objPerPage, setObjPerPage] = useState(10);
  const [pagePressed, setPagePressed] = useState(1);
  const [totalPagesNumber, setTotalPagesNumber] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [flag, setFlag] = useState(false);
  const [changeDone, setChangeDone] = useState(false);

  const [search, setSearch] = useState(false);

  const [filters, setFilters] = useState({
    company_id: 0,
    // office_id: 0,
    // province: "",
    name: "",
    surname: "",
    phone: "",
    email: "",
  });

  const [options, setOptions] = useState({
    zones: [],
    status: [
      { nombre: "Seleccionar", id: 0 },
      { nombre: "Activo", id: 1 },
      { nombre: "Inactivo", id: -1 },
    ],
    asignTo: [],
    companies: [],
    // offices: [],
  });

  const [loadingOptions, setLoadingOptions] = useState({
    status: false,
    asignTo: false,
    companies: false,
    // offices: false,
  });

  const fetchUsers = useCallback(async () => {
    setFlag(true);
    console.log(setCompanyFromUser);

    try {
      const response = await api.post(
        process.env.REACT_APP_API_URL + "/lawyers",
        {
          page: pagePressed,
          objPerPage,
          ...filters,
          ...(setCompanyFromUser && { company_id: setCompanyFromUser }),
        },
      );

      console.log(response);

      const {
        users,
        companies,
        //  offices, status
      } = response.data;

      if (setCompanyFromUser) {
        setUsersControlNumber(users?.total);
      }

      // if (users.total === 0) {
      //   Swal.fire({
      //     title: "No se han encontrado resultados",
      //     text: "Por favor intente nuevamente con otros párametros.",
      //     icon: "error",
      //     confirmButtonColor: "#1ab394",
      //     cancelButtonColor: "#d33",
      //     reverseButtons: true,
      //     showDenyButton: true,
      //     showConfirmButton: false,
      //     denyButtonText: "Volver",
      //   });
      // }

      setPageCount(users.last_page);
      setTotalPagesNumber(users.total);
      setUser(users.data);
      setOptions((prev) => ({
        ...prev,
        companies,
        // offices
      }));
    } catch (error) {
      console.error("Error en la respuesta del servidor:", error);
    } finally {
      setFlag(false);
    }
  }, [pagePressed, objPerPage, search, changeDone]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const handlePageClick = (event) => setPagePressed(event.selected + 1);

  const handleFilterChange = (name, value) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
    if (name === "objPerPage") {
      setObjPerPage(value > totalPagesNumber ? totalPagesNumber : value);
    }
  };

  const renderCellWithDefault = (value, defaultValue = "Sin asignar") => (
    <div className="spanClassForTables centerContent">
      {value || defaultValue}
    </div>
  );

  const renderStatus = (value) => (
    <div className="spanClassForTables centerContent">
      {options.status.find((s) => s.id === value)?.nombre || "Sin asignar"}
    </div>
  );

  const renderLogoCell = (value) => {
    return (
      <div className="spanClassForTables">
        {ImageCell(value) || "Sin asignar"}
      </div>
    );
  };

  const ImageCell = (value) => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        justifyContent: "center",
      }}>
      <img
        src={`${process.env.REACT_APP_BACKEND_HOST}/storage/company/${value.id}/${value.company_logo}?v=${Date.now()}`}
        alt="Company logo"
        style={{ height: "30px" }}
      />
      <b>{value.company_name}</b>
    </div>
  );

  const columns = useMemo(
    () => [
      {
        Header: "LISTA DE USUARIOS DE EMPRESA",
        columns: [
          {
            Header: "Empresa",
            accessor: "company_relation.company_name",
            Cell: ({ row }) => renderLogoCell(row.original.company_relation),
          },
          // {
          //   Header: "Despacho",
          //   accessor: "offices_relation.office_name",
          //   Cell: ({ value }) => renderCellWithDefault(value),
          // },
          {
            Header: "Nombre y Apellidos",
            accessor: "full_name",
            Cell: ({ value }) => renderCellWithDefault(value),
          },
          {
            Header: "Teléfono",
            accessor: "phone",
            Cell: ({ value }) => renderCellWithDefault(value, "SIN TELÉFONO"),
          },
          {
            Header: "Email",
            accessor: "email",
            Cell: ({ value }) => renderCellWithDefault(value, "SIN CORREO"),
          },
          {
            Header: "Estado",
            accessor: "status",
            Cell: ({ value }) => renderStatus(value),
          },
          {
            Header: "Rol",
            accessor: "full_rol_name",
            Cell: ({ value }) => renderCellWithDefault(value, "SIN FECHA"),
          },
          {
            Header: "Última conexión",
            accessor: "last_login",
            Cell: ({ value }) => renderCellWithDefault(value, "SIN FECHA"),
          },
          {
            Header: "Acciones",
            accessor: "id",
            Cell: ({ value }) => (
              <TableActions
                rute={"usuarios"}
                apiRute={"users"}
                value={value}
                showView
                showEdit
                showDelete
                module="users"
                setChangeDone={setChangeDone}
                changeDone={changeDone}
              />
            ),
          },
        ],
      },
    ],
    [],
  );
  // Cambios dentro del componente Usuarios

  // --- NUEVA FUNCIÓN PARA CARGAR OFICINAS DEPENDIENTES ---
  // const fetchOfficesByCompany = async (companyId) => {
  //   if (!companyId) return;

  //   setLoadingOptions((prev) => ({ ...prev, offices: true }));

  //   try {
  //     let queryUrl = `${process.env.REACT_APP_API_URL}/users/searchdatabycompany`;

  //     const response = await api.post(queryUrl, { company: companyId });

  //     setOptions((prev) => ({
  //       ...prev,
  //       offices: response.data.offices || [],
  //     }));
  //   } catch (error) {
  //     console.error("Error cargando oficinas:", error);
  //   } finally {
  //     setLoadingOptions((prev) => ({ ...prev, offices: false }));
  //   }
  // };

  // --- ACTUALIZAR EL onChange DE EMPRESA ---
  const handleCompanyChange = (_, value) => {
    const companyId = value?.id || 0;

    setFilters((prev) => ({
      ...prev,
      company_id: companyId,
      // office_id: 0, // limpiar oficina
    }));

    // if (companyId) {
    // fetchOfficesByCompany(companyId);
    // } else {
    // si no hay empresa, limpiar oficinas
    // setOptions((prev) => ({ ...prev, offices: [] }));
    // }
  };

  // --- CONFIGURACIÓN DE CAMPOS ACTUALIZADA ---
  const fieldsConfig = [
    {
      type: "autocomplete",
      label: "Empresa",
      options: options.companies,
      loading: loadingOptions.companies,
      onChange: handleCompanyChange,
      getOptionLabel: (option) => option.company_name,
      value: options.companies.find((c) => c.id === filters.company_id) || null,
    },
    // {
    //   type: "autocomplete",
    //   label: "Oficina",
    //   options: options.offices,
    //   loading: loadingOptions.offices,
    //   onChange: (_, value) => handleFilterChange("office_id", value?.id || 0),
    //   getOptionLabel: (option) => option.office_name,
    //   value: options.offices.find((o) => o.id === filters.office_id) || null,
    //   disabled: !filters.company_id, // deshabilitado si no hay empresa
    // },
    {
      type: "text",
      label: "Nombre",
      onChange: (e) => handleFilterChange("name", e.target.value),
      value: filters?.name,
    },
    {
      type: "text",
      label: "Apellido",
      onChange: (e) => handleFilterChange("surname", e.target.value),
      value: filters?.surname,
    },
    {
      type: "text",
      label: "Telefono",
      onChange: (e) => handleFilterChange("phone", e.target.value),
      value: filters?.phone,
    },
    {
      type: "text",
      label: "Email",
      onChange: (e) => handleFilterChange("email", e.target.value),
      value: filters?.email,
    },
  ];

  // --- MODIFICAR EL RENDERIZADO DE AUTOCOMPLETE PARA SOPORTAR "disabled" ---
  const renderField = (field, index) => (
    <Grid
      item
      xs={4}
      md={3}
      key={index}
      sx={{ padding: "5px", justifyContent: "center" }}>
      {field.type === "autocomplete" ? (
        <Autocomplete
          className={field.className}
          size="small"
          onChange={field.onChange}
          getOptionLabel={field.getOptionLabel}
          options={field.options}
          loading={field.loading}
          value={field.value}
          disabled={field.disabled || false}
          renderInput={(params) => (
            <TextField
              {...params}
              label={field.label}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <Fragment>
                    {field.loading && (
                      <CircularProgress color="inherit" size={20} />
                    )}
                    {params.InputProps.endAdornment}
                  </Fragment>
                ),
              }}
            />
          )}
        />
      ) : (
        <TextField
          onChange={field.onChange}
          label={field.label}
          variant="outlined"
          size="small"
          sx={{ width: "100%" }}
          value={field.value}
        />
      )}
    </Grid>
  );

  const handleFilterStates = () => {
    setFilters({
      company_id: 0,
      // office_id: 0,
      // province: "",
      name: "",
      surname: "",
      phone: "",
      email: "",
      phone: "",
    });
    setSearch(!search);
  };

  const content = (
    <div className="fatherContainer">
      <div className="mainContainer">
        <div className="subMainContainer">
          {(user === "" || flag) && <LinearProgress color="success" />}
          <Grid container className="filtersContainer">
            {fieldsConfig.map(renderField)}
            <Grid
              item
              xs={12}
              md={12}
              textAlign="center"
              mt={1}
              sx={{
                display: "inline-flex",
                gap: "5px",
                justifyContent: "center",
              }}>
              <CustomButtonPlusIcon
                icon={Search}
                text={"BUSCAR"}
                handleFunction={() => setSearch(!search)}
                position={"start"}
                variant={"outlined"}
                color={"info"}
              />
              <CustomButtonPlusIcon
                icon={CleaningServices}
                text={"LIMPIAR FILTROS"}
                handleFunction={handleFilterStates}
                position={"start"}
                variant={"outlined"}
                color={"error"}
              />
            </Grid>
          </Grid>
          {user && !flag && (
            <>
              <Table
                columns={columns}
                data={user}
                view={"usuario"}
                viewTitle={"usuarios"}
                totalPagesNumber={totalPagesNumber}
                icon={PersonAdd}
              />
              {totalPagesNumber > 10 && (
                <div className="tablePaginateContainer">
                  <div className="paginatorLeftText">
                    Mostrando {objPerPage * (pagePressed - 1) + 1} a{" "}
                    {Math.min(objPerPage * pagePressed, totalPagesNumber)} de{" "}
                    {totalPagesNumber} resultados
                  </div>
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel="Siguiente 🢂"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={2}
                    pageCount={pageCount}
                    previousLabel="🢀 Anterior"
                    containerClassName="pagination"
                    activeClassName="active"
                    pageClassName="page-item"
                    nextClassName="page-item"
                    previousClassName="page-item"
                    disabledClassName="disabled"
                    forcePage={pagePressed - 1}
                  />
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );

  useEffect(() => {
    if (pagePressed > pageCount) {
      setPagePressed(1);
    }
  }, [pageCount]);

  return (
    <>
      {flagToShow ? (
        <div>
          <CommonSubHeader title="Configuración" subTitle="Usuarios" />

          {content}
        </div>
      ) : (
        <div className="fatherContainer">
          <div className="mainContainer">{content}</div>
        </div>
      )}
    </>
  );
}

export default Usuarios;
